import { resizeImage } from './resizeImage'
const TARGET_FILE_SIZE = 1024 * 1024 // 1MB
const MAX_IMAGE_DIMENSIONS = { width: 720, height: 960 }

export const resizeMultipleImage = async (files: File[]): Promise<File[]> => {
  const promiseAllImage = files.map(async (file) => {
    if (file.size > TARGET_FILE_SIZE) {
      const resizedImageFile = await resizeImage(
        file,
        MAX_IMAGE_DIMENSIONS.width,
        MAX_IMAGE_DIMENSIONS.height,
        TARGET_FILE_SIZE,
      )
      return resizedImageFile
    }
    return file
  })
  return Promise.all(promiseAllImage)
}
